import { render } from "./Studies.vue?vue&type=template&id=15fa6bf8"
const script = {}
script.render = render

export default script